module.exports = __webpack_public_path__ + "static/img/yytx36.58354e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx36.png
// module id = 903
// module chunks = 0